import React, {Component} from "react";

import './_modal.scss';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import ReactLoading from 'react-loading';

export default class NTMModal extends Component {

	render() {
		return (
			<Modal isOpen={true}>
				<ModalHeader>Un attimo...</ModalHeader>
				<ReactLoading type={"spokes"} color={"#69ABF8"} className={"center"}/>
			</Modal>
		);
	}
}